
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup } from 'react-bootstrap';
import { Link, useHistory} from 'react-router-dom';

import { Routes } from "../routes";
import BgImage from "../assets/img/illustrations/signin.svg";
import { useAuth } from "../hooks/auth.hook";
import * as yup from 'yup';
import { useFormik } from 'formik';
import LoadingComponent from "../components/LoadingComponent";
import { errorToast, successToast} from "../utils/toast"

function SignUp () {
  let auth = useAuth();
  let history = useHistory();

  const RegisterSchema = yup.object({
    firstname: yup.string().max(64).required('Debes ingresar un tu nombre'),
    lastname: yup.string().max(64).required('Debes ingresar tu apellido'),
    email: yup.string().email("Debes ingresar un correo electrónico válido").max(320).required('El correo electrónico no puede estar vacío')
    .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Por favor ingresa un email válido'),
    iamafiliate: yup.bool(),
    ib_number: yup.string().max(64).when("iamafiliate", {
      is: true,
      then: yup.string().required("Debes indicar tu número de IB para poder validarte")
    }),
    password: yup.string().max(128).min(6,'Se requiere una contraseña de al menos 6 caracteres').required("La contraseña no puede estar vacía"),
    checkPassword: yup.string().oneOf([yup.ref('password')],"Las contraseñas deben ser iguales").required('Debes confirmar tu contraseña'),
    terms: yup.bool().oneOf([true], 'Para registrarte debes aceptar nuestros términos y condiciones').required('Para registrarte debes aceptar nuestros términos y condiciones'),
  });
  
  const handleRegisterSubmit = (values, { setSubmitting }) => {
    let fullname = values.firstname + ' ' + values.lastname
    //start loader here
    setSubmitting(true);
    setIsLoading(true);
    auth.signup(fullname, values.email, values.password, values.terms ? 'on': 'off', values.iamafiliate ? 'on': 'off', values.ib_number)
        .then((result) => {
            // result is true always
            successToast("Te has registrado exitosamente en la plataforma!");
            setTimeout(() => {
              history.replace("/login");
            }, 1500);
        })
        .catch((error) => {
          //remove loader
          setIsLoading(false);
          errorToast(error);
          console.log(error)
        })
        .finally(() => {
            setSubmitting(false);
            setIsLoading(false);
        });
  };
  const formik = useFormik({
    initialValues: { firstname: '', lastname: '', email: '', password: '', checkPassword: '', terms: false },
    validationSchema: RegisterSchema,
    onSubmit: handleRegisterSubmit,
  });
  const [isLoading, setIsLoading] = useState(false);

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col xs={12} className="d-flex align-items-center justify-content-center" style={{position: "relative"}}>
                {isLoading && (
                      <>
                        <LoadingComponent className="d-flex align-items-center justify-content-center fmxw-500"></LoadingComponent>
                      </>
                )}
              <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Crear una cuenta</h3>
                </div>
                <Form className="mt-4" onSubmit={formik.handleSubmit} method="post">
                  <Form.Group className="mb-4">
                    <Form.Label>Nombre</Form.Label>
                    <InputGroup>
                      <Form.Control
                      required 
                      id="firstname"
                      type="text" 
                      maxLength="128"
                      placeholder="Trader"
                      className={` ${(formik.touched.firstname && formik.errors.firstname) ? "invalid" : ""} ${(formik.touched.firstname && !formik.errors.firstname) ? "valid" : ""}`}
                      value={formik.values.firstname}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}/>
                    </InputGroup>
                    {formik.touched.firstname && formik.errors.firstname  &&
                            <div style={{ position: "absolute", display: "flex" }}>
                                <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.firstname}</small>
                            </div>
                      }
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Apellido</Form.Label>
                    <InputGroup>
                        <Form.Control
                          required 
                          id="lastname"
                          type="text" 
                          maxLength="128"
                          placeholder="Vitecapital"
                          className={` ${(formik.touched.lastname && formik.errors.lastname) ? "invalid" : ""} ${(formik.touched.lastname && !formik.errors.lastname) ? "valid" : ""}`}
                          value={formik.values.lastname}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}/>
                    </InputGroup>
                    {formik.touched.lastname && formik.errors.lastname  &&
                            <div style={{ position: "absolute", display: "flex" }}>
                                <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.lastname}</small>
                            </div>
                      }
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Tu correo electrónico</Form.Label>
                       <InputGroup>
                         <Form.Control
                            required 
                            id="email"
                            type="text" 
                            maxLength="320"
                            placeholder="trader@vitecapital.com"
                            className={` ${(formik.touched.email && formik.errors.email) ? "invalid" : ""} ${(formik.touched.email && !formik.errors.email) ? "valid" : ""}`}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.email && formik.errors.email  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.email}</small>
                                </div>
                              }
                  </Form.Group>
                  <FormCheck type="checkbox" className="d-flex mb-4">
                    <FormCheck.Input id="iamafiliate" className="me-2" onBlur={formik.handleBlur} name="iamafiliate" onChange={formik.handleChange} value={formik.values.iamafiliate} />
                    <FormCheck.Label htmlFor="iamafiliate">
                      Soy Afiliado Comercial
                    </FormCheck.Label>
                  </FormCheck>
                  {formik.values.iamafiliate !== undefined && formik.values.iamafiliate !== null && formik.values.iamafiliate && (
                    <Form.Group className="mb-4">
                    <Form.Label>Número de IB</Form.Label>
                       <InputGroup>
                       <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                         <Form.Control
                            required 
                            id="ib_number"
                            type="text" 
                            maxLength="64"
                            placeholder="801XXXXXXX"
                            className={` ${(formik.touched.ib_number && formik.errors.ib_number) ? "invalid" : ""} ${(formik.touched.ib_number && !formik.errors.ib_number) ? "valid" : ""}`}
                            value={formik.values.ib_number}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.ib_number && formik.errors.ib_number  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.ib_number}</small>
                                </div>
                              }
                    </Form.Group>
                  )}
                  <Form.Group className="mb-4">
                    <Form.Label>Tu contraseña</Form.Label>
                       <InputGroup>
                       <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                         <Form.Control
                            required 
                            id="password"
                            type="password" 
                            maxLength="128"
                            placeholder="Contraseña"
                            className={` ${(formik.touched.password && formik.errors.password) ? "invalid" : ""} ${(formik.touched.password && !formik.errors.password) ? "valid" : ""}`}
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.password && formik.errors.password  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.password}</small>
                                </div>
                              }
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Confirmar contraseña</Form.Label>
                       <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                         <Form.Control
                            required 
                            id="checkPassword"
                            type="password" 
                            maxLength="128"
                            placeholder="Confirmar contraseña"
                            className={` ${(formik.touched.checkPassword && formik.errors.checkPassword) ? "invalid" : ""} ${(formik.touched.checkPassword && !formik.errors.checkPassword) ? "valid" : ""}`}
                            value={formik.values.checkPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.checkPassword && formik.errors.checkPassword  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.checkPassword}</small>
                                </div>
                              }
                  </Form.Group>
                  <FormCheck type="checkbox" className="d-flex mb-4">
                    <FormCheck.Input required id="terms" className="me-2" onBlur={formik.handleBlur} name="terms" onChange={formik.handleChange} value={formik.values.terms} />
                    <FormCheck.Label htmlFor="terms">
                      Yo acepto a los <Card.Link>terminos y condiciones</Card.Link>
                    </FormCheck.Label>
                  </FormCheck>
                  {formik.touched.terms && formik.errors.terms  &&
                    <div style={{ display: "flex", marginBottom: "10px"}}>
                      <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.terms}</small>
                    </div>
                    }
                  <Button variant="primary" type="submit" className="w-100" disabled={formik.isSubmitting || Object.keys(formik.errors).length > 0}>
                    Registrarse
                  </Button>
                </Form>
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    ¿Ya tienes una cuenta?
                    <Card.Link as={Link} to={Routes.Signin.path} className="fw-bold">
                      {` Ingresa aquí `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default SignUp;
